export const CSAT_MODE_DISABLED = 0
export const CSAT_MODE_INBOUND = 1
export const CSAT_MODE_OUTBOUND = 2
export const CSAT_MODE_BOTH = 3
